import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/inovaa.png";

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700;9..40,800&family=DM+Mono:wght@400;500&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  @keyframes bootSweep {
    0%   { transform: translateY(-100%); opacity:1; }
    100% { transform: translateY(220vh);  opacity:0; }
  }
  @keyframes fadeIn   { from{opacity:0} to{opacity:1} }
  @keyframes fadeUp   { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
  @keyframes fadeRight{ from{opacity:0;transform:translateX(28px)} to{opacity:1;transform:translateX(0)} }

  @keyframes orb1 {
    0%,100%{transform:translate(0,0) scale(1)}
    33%    {transform:translate(70px,-50px) scale(1.10)}
    66%    {transform:translate(-40px,60px) scale(0.93)}
  }
  @keyframes orb2 {
    0%,100%{transform:translate(0,0) scale(1)}
    40%    {transform:translate(-90px,40px) scale(1.07)}
    70%    {transform:translate(60px,-70px) scale(0.94)}
  }
  @keyframes orb3 {
    0%,100%{transform:translate(0,0) scale(1)}
    30%    {transform:translate(50px,80px) scale(1.14)}
    65%    {transform:translate(-70px,-30px) scale(0.91)}
  }
  @keyframes shimmerSweep {
    0%  {background-position:-300% 0}
    100%{background-position:400% 0}
  }
  @keyframes gridFade {
    0%,100%{opacity:0.022} 50%{opacity:0.055}
  }
  @keyframes floatUp {
    0%  {transform:translate(0,0) scale(1);opacity:var(--op)}
    100%{transform:translate(var(--dx),-130px) scale(0);opacity:0}
  }
  @keyframes logoShine {
    0%  {background-position:-700px center}
    100%{background-position:700px center}
  }
  @keyframes glowPulse {
    0%,100%{opacity:0.55}
    50%    {opacity:1.0}
  }
  @keyframes glowPulseGold {
    0%,100%{opacity:0.50; filter:drop-shadow(0 0 6px rgba(245,158,11,0.50));}
    50%    {opacity:1.0;  filter:drop-shadow(0 0 18px rgba(245,158,11,0.90)) drop-shadow(0 0 32px rgba(14,165,233,0.40));}
  }
  @keyframes btnShimmer { 0%{left:-120%} 100%{left:200%} }
  @keyframes spin { to{transform:rotate(360deg)} }
  @keyframes noiseScroll {
    0%  {background-position:0 0}
    100%{background-position:200px 200px}
  }
  @keyframes pinPulse {
    0%,100%{transform:scale(1); filter:drop-shadow(0 0 4px rgba(245,158,11,0.70));}
    50%    {transform:scale(1.18); filter:drop-shadow(0 0 12px rgba(245,158,11,1.0)) drop-shadow(0 0 24px rgba(14,165,233,0.50));}
  }
  @keyframes scanLine {
    0%  {top:-10%}
    100%{top:110%}
  }
  @keyframes workerBob {
    0%,100%{transform:translateY(0)}
    50%    {transform:translateY(-3px)}
  }
  @keyframes diagramDraw {
    0%  {stroke-dashoffset:400}
    100%{stroke-dashoffset:0}
  }
  @keyframes pointAppear {
    0%  {opacity:0;transform:scale(0)}
    60% {opacity:1;transform:scale(1.3)}
    100%{opacity:1;transform:scale(1)}
  }
  @keyframes ripple {
    0%  {r:4;opacity:0.9;}
    100%{r:22;opacity:0;}
  }

  /* ── LAYOUT ─────────────────────────────────── */
  .ml-root {
    display:flex; width:100%; height:100vh;
    background:#080C18; font-family:'DM Sans',sans-serif;
    overflow:hidden; position:relative;
  }
  .ml-boot {
    position:fixed; inset:0;
    background:linear-gradient(180deg,
      transparent 0%,rgba(245,158,11,0.09) 49%,
      rgba(14,165,233,0.07) 51%,transparent 100%
    );
    z-index:9999; pointer-events:none;
    animation:bootSweep 1.0s 0.05s cubic-bezier(0.4,0,0.2,1) both;
  }
  .ml-scanlines {
    position:fixed; inset:0;
    background:repeating-linear-gradient(0deg,
      transparent,transparent 2px,
      rgba(0,0,0,0.038) 2px,rgba(0,0,0,0.038) 4px
    );
    pointer-events:none; z-index:9998;
  }

  /* ── LEFT ────────────────────────────────────── */
  .ml-left {
    flex:1; position:relative; overflow:hidden; background:#060A15;
  }
  .ml-deep-bg {
    position:absolute; inset:0;
    background:
      radial-gradient(ellipse 100% 70% at 50% 110%,rgba(245,158,11,0.055) 0%,transparent 65%),
      radial-gradient(ellipse 80%  60% at 8%  50%, rgba(14,165,233,0.045) 0%,transparent 60%),
      radial-gradient(ellipse 55%  45% at 92% 18%, rgba(251,191,36,0.022) 0%,transparent 55%),
      linear-gradient(165deg,#060A16 0%,#080D1B 50%,#050914 100%);
  }
  .ml-noise {
    position:absolute; inset:0; opacity:0.018;
    background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
    background-size:200px 200px; animation:noiseScroll 8s linear infinite;
    pointer-events:none; z-index:1;
  }
  .ml-orb { position:absolute; border-radius:50%; filter:blur(90px); pointer-events:none; z-index:2; }
  .ml-orb-1 { width:520px;height:520px;left:-80px;top:-60px;   background:radial-gradient(circle,rgba(14,165,233,0.18) 0%,transparent 70%);animation:orb1 18s ease-in-out infinite; }
  .ml-orb-2 { width:600px;height:600px;right:-120px;bottom:-80px; background:radial-gradient(circle,rgba(245,158,11,0.14) 0%,transparent 70%);animation:orb2 22s ease-in-out infinite; }
  .ml-orb-3 { width:400px;height:400px;left:32%;top:18%;       background:radial-gradient(circle,rgba(251,191,36,0.07) 0%,transparent 70%);animation:orb3 15s ease-in-out infinite; }
  .ml-shimmer {
    position:absolute; inset:0; pointer-events:none; z-index:3;
    background:linear-gradient(105deg,
      transparent 0%,transparent 38%,
      rgba(14,165,233,0.030) 46%,rgba(245,158,11,0.048) 50%,
      rgba(14,165,233,0.030) 54%,transparent 62%,transparent 100%
    );
    background-size:300% 100%; animation:shimmerSweep 8s 2s ease-in-out infinite;
  }
  .ml-grid {
    position:absolute; inset:0; z-index:3; pointer-events:none;
    background-image:
      linear-gradient(rgba(14,165,233,0.85) 1px,transparent 1px),
      linear-gradient(90deg,rgba(14,165,233,0.85) 1px,transparent 1px);
    background-size:64px 64px; background-position:center center;
    animation:gridFade 6s ease-in-out infinite;
  }
  .ml-hline {
    position:absolute; left:0; right:0; height:1px; pointer-events:none; z-index:4;
    background:linear-gradient(90deg,
      transparent 0%,rgba(245,158,11,0.10) 20%,
      rgba(245,158,11,0.25) 50%,rgba(14,165,233,0.10) 80%,transparent 100%
    );
  }
  .ml-scene { position:absolute; bottom:0; left:0; right:0; z-index:6; pointer-events:none; }
  .ml-particle {
    position:absolute; border-radius:50%;
    animation:floatUp ease-out infinite; z-index:5; pointer-events:none;
  }
  .ml-left-inner {
    position:absolute; inset:0; z-index:10;
    display:flex; flex-direction:column; justify-content:space-between;
    padding:52px 60px 52px;
  }
  .ml-brand { animation:fadeUp 0.8s 1.5s both; }
  .ml-brand-mark {
    font-family:'Bebas Neue',sans-serif; font-size:72px; letter-spacing:0.06em; line-height:0.85;
    background:linear-gradient(105deg,#fff 0%,#FDE68A 15%,#F59E0B 30%,#0EA5E9 50%,#F59E0B 68%,#fff 85%,#fff 100%);
    background-size:700px 100%; -webkit-background-clip:text;
    -webkit-text-fill-color:transparent; background-clip:text;
    animation:logoShine 5s 3.0s ease-in-out infinite; display:block;
  }
  .ml-brand-logo { display:block; height:84px; width:auto; object-fit:contain; margin-bottom:6px; filter:drop-shadow(0 4px 18px rgba(219,39,119,0.25)); }
  .ml-badge-logo { display:block; height:26px; width:auto; object-fit:contain; }
  .ml-brand-sub {
    display:block; font-family:'DM Mono',monospace; font-size:10px;
    letter-spacing:0.28em; color:rgba(245,158,11,0.42); margin-top:6px; text-transform:uppercase;
  }
  .ml-hero { display:flex; flex-direction:column; gap:16px; }
  .ml-hero-eyebrow { display:flex; align-items:center; gap:10px; animation:fadeUp 0.8s 1.8s both; }
  .ml-eyebrow-line { height:1px; width:32px; background:linear-gradient(90deg,#0EA5E9,#F59E0B); display:inline-block; }
  .ml-eyebrow-text { font-size:10px; font-weight:700; letter-spacing:0.20em; color:rgba(245,158,11,0.58); text-transform:uppercase; }
  .ml-hero-title {
    font-size:clamp(40px,4.2vw,60px); font-weight:800; color:rgba(255,255,255,0.90);
    letter-spacing:-0.04em; line-height:1.07; max-width:460px; animation:fadeUp 0.9s 2.0s both;
  }
  .ml-hero-title em {
    font-style:normal;
    background:linear-gradient(90deg,#0EA5E9 0%,#F59E0B 100%);
    -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text;
  }
  .ml-hero-body {
    font-size:13px; color:rgba(255,255,255,0.22); font-weight:400;
    line-height:1.75; max-width:360px; animation:fadeUp 0.9s 2.2s both;
  }
  .ml-powered-wrap { display:flex; flex-direction:column; gap:12px; animation:fadeUp 0.8s 2.6s both; }
  .ml-powered-divider { height:1px; width:180px; background:linear-gradient(90deg,rgba(245,158,11,0.22),rgba(14,165,233,0.15),transparent); }
  .ml-powered-label { font-family:'DM Mono',monospace; font-size:9px; letter-spacing:0.18em; color:rgba(255,255,255,0.16); text-transform:uppercase; }
  .ml-badge {
    display:inline-flex; align-items:center; gap:10px; margin-top:4px;
  }
  .ml-badge-icon {
    width:32px; height:32px; border-radius:9px;
    background:linear-gradient(135deg,#6D28D9,#DB2777,#F97316);
    display:flex; align-items:center; justify-content:center;
    font-family:'Bebas Neue',sans-serif; font-size:17px; color:#fff; letter-spacing:0.05em;
    box-shadow:0 0 18px rgba(219,39,119,0.45); animation:glowPulseGold 3s ease-in-out infinite;
  }
  .ml-badge-text {
    font-family:'Bebas Neue',sans-serif; font-size:22px; letter-spacing:0.14em;
    background:linear-gradient(90deg,#0EA5E9,#F59E0B);
    -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text;
  }
  .ml-badge-sub {
    font-family:'DM Mono',monospace; font-size:8px; letter-spacing:0.20em;
    color:rgba(245,158,11,0.35); display:block; margin-top:1px; text-transform:uppercase;
  }

  /* ── DIVIDER ─────────────────────────────────── */
  .ml-divider {
    width:1px; flex-shrink:0; position:relative;
    background:linear-gradient(180deg,transparent 0%,rgba(255,255,255,0.048) 15%,rgba(255,255,255,0.048) 85%,transparent 100%);
  }
  .ml-divider-gem {
    position:absolute; top:50%; left:50%; transform:translate(-50%,-50%);
    width:8px; height:8px; border-radius:50%;
    background:linear-gradient(135deg,#0EA5E9,#F59E0B);
    box-shadow:0 0 16px 4px rgba(245,158,11,0.30); animation:glowPulse 2.5s ease-in-out infinite;
  }

  /* ── RIGHT ───────────────────────────────────── */
  .ml-right {
    width:460px; flex-shrink:0; display:flex; align-items:center; justify-content:center;
    background:#080C18; position:relative; overflow:hidden; padding:48px 44px;
  }
  .ml-right::before {
    content:''; position:absolute; inset:0; pointer-events:none;
    background:
      radial-gradient(ellipse 90% 50% at 50% 0%,  rgba(14,165,233,0.038) 0%,transparent 70%),
      radial-gradient(ellipse 70% 40% at 50% 100%,rgba(245,158,11,0.028) 0%,transparent 65%);
  }
  .ml-bracket { position:absolute; width:48px; height:48px; pointer-events:none; z-index:5; }
  .ml-bracket-tr { top:22px;right:22px; border-top:1px solid rgba(245,158,11,0.16); border-right:1px solid rgba(245,158,11,0.16); border-radius:0 8px 0 0; animation:fadeIn 1s 2.8s both; }
  .ml-bracket-bl { bottom:22px;left:22px; border-bottom:1px solid rgba(14,165,233,0.16); border-left:1px solid rgba(14,165,233,0.16); border-radius:0 0 0 8px; animation:fadeIn 1s 2.8s both; }
  .ml-card { width:100%; max-width:360px; position:relative; z-index:10; }
  .ml-card-head { margin-bottom:36px; animation:fadeRight 0.7s 1.6s both; }
  .ml-eyebrow-row { display:flex; align-items:center; gap:8px; margin-bottom:13px; }
  .ml-eyebrow-dash { height:1px; width:22px; background:linear-gradient(90deg,#0EA5E9,#F59E0B); }
  .ml-eyebrow-tag { font-size:9px; font-weight:700; letter-spacing:0.18em; color:rgba(245,158,11,0.52); text-transform:uppercase; }
  .ml-card-title { font-size:32px; font-weight:800; color:#fff; letter-spacing:-0.04em; line-height:1.05; margin-bottom:8px; }
  .ml-card-sub { font-size:12px; color:rgba(255,255,255,0.24); font-weight:400; line-height:1.6; }
  .ml-field { margin-bottom:18px; }
  .ml-field:nth-child(1){animation:fadeRight 0.7s 1.9s both}
  .ml-field:nth-child(2){animation:fadeRight 0.7s 2.05s both}
  .ml-field:nth-child(3){animation:fadeRight 0.7s 2.20s both}
  .ml-label { display:flex; justify-content:space-between; align-items:center; font-size:10px; font-weight:700; color:rgba(255,255,255,0.28); letter-spacing:0.12em; text-transform:uppercase; margin-bottom:8px; }
  .ml-input-wrap { position:relative; }
  .ml-input-icon { position:absolute; left:14px; top:50%; transform:translateY(-50%); color:rgba(255,255,255,0.17); font-size:14px; line-height:1; pointer-events:none; z-index:2; }
  .ml-input {
    width:100%; padding:14px 14px 14px 42px;
    background:rgba(255,255,255,0.034); border:1px solid rgba(255,255,255,0.072);
    border-radius:11px; color:#E2E8F0; font-size:13px;
    font-family:'DM Sans',sans-serif; font-weight:500;
    outline:none; transition:border-color 0.2s,background 0.2s,box-shadow 0.2s; color-scheme:dark;
  }
  .ml-input::placeholder { color:rgba(255,255,255,0.14); }
  .ml-input:focus { border-color:rgba(245,158,11,0.38); background:rgba(245,158,11,0.028); box-shadow:0 0 0 3px rgba(245,158,11,0.07),0 0 14px rgba(245,158,11,0.09); }
  .ml-input.has-error { border-color:rgba(248,113,113,0.38); background:rgba(248,113,113,0.028); }
  .ml-uline { position:absolute; bottom:-1px; left:10px; right:10px; height:2px; border-radius:2px; background:linear-gradient(90deg,#0EA5E9,#F59E0B); transform:scaleX(0); transform-origin:left; transition:transform 0.3s cubic-bezier(0.4,0,0.2,1); }
  .ml-input:focus ~ .ml-uline { transform:scaleX(1); }
  .ml-error-msg { font-size:10px; color:#F87171; font-weight:700; margin-top:5px; display:flex; align-items:center; gap:5px; animation:fadeUp 0.2s ease both; }
  .ml-eye { position:absolute; right:13px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:rgba(255,255,255,0.19); font-size:13px; padding:4px; transition:color 0.2s; z-index:2; }
  .ml-eye:hover { color:rgba(255,255,255,0.48); }
  .ml-alert { background:rgba(248,113,113,0.07); border:1px solid rgba(248,113,113,0.20); border-radius:9px; padding:10px 13px; font-size:11px; color:#F87171; font-weight:600; display:flex; align-items:center; gap:7px; margin-bottom:16px; animation:fadeUp 0.25s ease both; }
  .ml-btn {
    width:100%; padding:15px; border:none; border-radius:12px;
    background:linear-gradient(90deg,#0EA5E9 0%,#F59E0B 50%,#0EA5E9 100%);
    background-size:200% 100%; background-position:100% 0; color:#fff;
    font-family:'DM Sans',sans-serif; font-size:13px; font-weight:800;
    letter-spacing:0.10em; text-transform:uppercase; cursor:pointer;
    position:relative; overflow:hidden;
    transition:background-position 0.5s ease,transform 0.15s,box-shadow 0.3s;
    box-shadow:0 4px 22px rgba(245,158,11,0.22),0 1px 0 rgba(255,255,255,0.07) inset;
    animation:fadeRight 0.7s 2.35s both;
  }
  .ml-btn:hover:not(:disabled){ background-position:0 0; box-shadow:0 6px 36px rgba(245,158,11,0.38); transform:translateY(-1px); }
  .ml-btn:active:not(:disabled){ transform:translateY(0); }
  .ml-btn:disabled{ opacity:0.5; cursor:not-allowed; transform:none; }
  .ml-btn-shine { position:absolute; top:0; left:-120%; width:55%; height:100%; background:linear-gradient(90deg,transparent,rgba(255,255,255,0.18),transparent); animation:btnShimmer 2.8s 4.5s ease-in-out infinite; }
  .ml-footer { text-align:center; margin-top:22px; font-size:11px; color:rgba(255,255,255,0.18); animation:fadeRight 0.7s 2.5s both; }
  .ml-spin { display:inline-block; width:13px; height:13px; border:2px solid rgba(255,255,255,0.25); border-top-color:white; border-radius:50%; animation:spin 0.7s linear infinite; vertical-align:middle; margin-right:7px; }
`;

// ─── PARTICLES ────────────────────────────────────────────────────
const PARTICLES = Array.from({ length: 28 }, (_, i) => ({
  id: i,
  x: 5 + Math.random() * 90,
  y: 5 + Math.random() * 58,
  delay: Math.random() * 6,
  dur: 3.5 + Math.random() * 4,
  dx: `${-20 + Math.random() * 40}px`,
  size: 1 + Math.random() * 2,
  op: 0.10 + Math.random() * 0.32,
  color: i % 3 === 0
    ? 'rgba(245,158,11,0.85)'
    : i % 3 === 1
    ? 'rgba(14,165,233,0.85)'
    : 'rgba(251,191,36,0.60)',
}));

// ─── SVG SCENE — Diagram pin editor illustration ──────────────────
const Scene = () => (
  <svg viewBox="0 0 900 420" preserveAspectRatio="xMidYMax meet"
    style={{ width: '100%', display: 'block' }} xmlns="http://www.w3.org/2000/svg">

    <defs>
      <linearGradient id="groundGrad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#0A1428"/>
        <stop offset="100%" stopColor="#050C18"/>
      </linearGradient>
      <linearGradient id="panelBody" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#0D1F3C"/>
        <stop offset="100%" stopColor="#07101E"/>
      </linearGradient>
      <linearGradient id="panelGlare" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="rgba(14,165,233,0.22)"/>
        <stop offset="60%" stopColor="rgba(245,158,11,0.06)"/>
        <stop offset="100%" stopColor="transparent"/>
      </linearGradient>
      <linearGradient id="diagramGrad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#0C1A30"/>
        <stop offset="100%" stopColor="#070F1E"/>
      </linearGradient>
      <radialGradient id="fogGrad" cx="50%" cy="100%" r="60%">
        <stop offset="0%" stopColor="rgba(245,158,11,0.06)"/>
        <stop offset="100%" stopColor="transparent"/>
      </radialGradient>
      <filter id="pinGlow" x="-80%" y="-80%" width="260%" height="260%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="3" result="blur"/>
        <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
      <filter id="screenGlow" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur"/>
        <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>

    {/* Ground */}
    <rect x="0" y="370" width="900" height="50" fill="url(#groundGrad)"/>
    <line x1="0" y1="370" x2="900" y2="370" stroke="rgba(245,158,11,0.08)" strokeWidth="1"/>
    <ellipse cx="450" cy="372" rx="440" ry="24" fill="url(#fogGrad)">
      <animate attributeName="rx" values="400;460;400" dur="8s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="0.6;1.0;0.6" dur="7s" repeatCount="indefinite"/>
    </ellipse>

    {/* ── LARGE DIAGRAM BOARD — center stage ── */}
    {/* Stand legs */}
    <line x1="310" y1="340" x2="270" y2="370" stroke="#0A1628" strokeWidth="5" strokeLinecap="round"/>
    <line x1="590" y1="340" x2="630" y2="370" stroke="#0A1628" strokeWidth="5" strokeLinecap="round"/>
    <line x1="310" y1="340" x2="590" y2="340" stroke="#0A1628" strokeWidth="4" strokeLinecap="round"/>
    {/* cross brace */}
    <line x1="330" y1="330" x2="570" y2="330" stroke="#0A1830" strokeWidth="3" strokeLinecap="round" opacity="0.7"/>

    {/* Board frame */}
    <rect x="190" y="100" width="420" height="240" rx="8"
      fill="#07101C" stroke="rgba(14,165,233,0.22)" strokeWidth="1.5"/>
    {/* inner screen */}
    <rect x="198" y="108" width="404" height="224" rx="5"
      fill="url(#diagramGrad)" stroke="rgba(14,165,233,0.10)" strokeWidth="0.8"/>

    {/* Screen scan line */}
    <rect x="198" y="108" width="404" height="4" rx="2"
      fill="rgba(14,165,233,0.06)" style={{ animation: 'scanLine 4s linear infinite' }}/>

    {/* ── Diagram content on screen — solar site layout ── */}
    {/* Row labels */}
    {['A', 'B', 'C'].map((label, i) => (
      <text key={label} x="212" y={152 + i * 58} fill="rgba(14,165,233,0.30)"
        fontSize="9" fontFamily="DM Mono" letterSpacing="0.1em">{label}</text>
    ))}

    {/* Panel rows drawn as lines animating in */}
    {[0, 1, 2].map(row => (
      <g key={row}>
        {[0, 1, 2, 3, 4].map(col => (
          <rect key={col}
            x={228 + col * 68} y={138 + row * 58}
            width={52} height={34} rx="3"
            fill="rgba(14,165,233,0.06)"
            stroke="rgba(14,165,233,0.18)" strokeWidth="0.8">
            <animate attributeName="opacity"
              values="0.5;0.9;0.5"
              dur={`${3 + col * 0.3 + row * 0.2}s`}
              repeatCount="indefinite"/>
          </rect>
        ))}
        {/* row connector line */}
        <line x1="228" y1={155 + row * 58} x2="560" y2={155 + row * 58}
          stroke="rgba(14,165,233,0.08)" strokeWidth="0.6" strokeDasharray="4,3"/>
      </g>
    ))}

    {/* Inverter box bottom of diagram */}
    <rect x="362" y="282" width="76" height="30" rx="4"
      fill="rgba(14,165,233,0.07)" stroke="rgba(14,165,233,0.20)" strokeWidth="0.8"/>
    <text x="400" y="301" fill="rgba(14,165,233,0.35)"
      fontSize="8" fontFamily="DM Mono" textAnchor="middle" letterSpacing="0.08em">INVERTER</text>
    {/* connection lines from rows to inverter */}
    <line x1="400" y1="282" x2="400" y2="265" stroke="rgba(14,165,233,0.15)" strokeWidth="1" strokeDasharray="3,2"/>

    {/* ── DIAGRAM PINS — the whole point of Mideast ── */}
    {/* Pin 1 — top-left cluster */}
    <g filter="url(#pinGlow)" style={{ animation: 'pinPulse 2.4s 0s ease-in-out infinite' }}>
      <circle cx="254" cy="155" r="7" fill="#F59E0B" opacity="0.95"/>
      <circle cx="254" cy="155" r="4" fill="#FDE68A"/>
      <text x="254" y="159" fill="#080C18" fontSize="6" fontFamily="DM Sans"
        fontWeight="800" textAnchor="middle">1</text>
      <circle cx="254" cy="155" r="7" fill="none" stroke="rgba(245,158,11,0.70)" strokeWidth="1.2">
        <animate attributeName="r" values="7;20" dur="2.4s" repeatCount="indefinite"/>
        <animate attributeName="opacity" values="0.8;0" dur="2.4s" repeatCount="indefinite"/>
      </circle>
    </g>
    {/* Note popup for pin 1 */}
    <g style={{ animation: 'fadeIn 0.5s 3.5s both' }}>
      <rect x="264" y="130" width="100" height="28" rx="5"
        fill="#0D1829" stroke="rgba(245,158,11,0.30)" strokeWidth="0.8"/>
      <rect x="264" y="130" width="100" height="4" rx="5"
        fill="rgba(245,158,11,0.22)"/>
      <text x="272" y="146" fill="rgba(245,158,11,0.70)"
        fontSize="7" fontFamily="DM Sans" fontWeight="700">⚠ Low PR – Attention</text>
      <text x="272" y="155" fill="rgba(255,255,255,0.25)"
        fontSize="6.5" fontFamily="DM Mono">Row A · Col 1</text>
      {/* line to pin */}
      <line x1="264" y1="144" x2="261" y2="155" stroke="rgba(245,158,11,0.30)" strokeWidth="0.8"/>
    </g>

    {/* Pin 2 — middle, critical */}
    <g filter="url(#pinGlow)" style={{ animation: 'pinPulse 2.1s 0.6s ease-in-out infinite' }}>
      <circle cx="400" cy="213" r="7" fill="#EF4444" opacity="0.95"/>
      <circle cx="400" cy="213" r="4" fill="#FCA5A5"/>
      <text x="400" y="217" fill="#fff" fontSize="6" fontFamily="DM Sans"
        fontWeight="800" textAnchor="middle">2</text>
      <circle cx="400" cy="213" r="7" fill="none" stroke="rgba(239,68,68,0.70)" strokeWidth="1.2">
        <animate attributeName="r" values="7;20" dur="2.1s" begin="0.6s" repeatCount="indefinite"/>
        <animate attributeName="opacity" values="0.8;0" dur="2.1s" begin="0.6s" repeatCount="indefinite"/>
      </circle>
    </g>

    {/* Pin 3 — right side, info */}
    <g filter="url(#pinGlow)" style={{ animation: 'pinPulse 2.7s 1.2s ease-in-out infinite' }}>
      <circle cx="526" cy="155" r="7" fill="#0EA5E9" opacity="0.95"/>
      <circle cx="526" cy="155" r="4" fill="#BAE6FD"/>
      <text x="526" y="159" fill="#080C18" fontSize="6" fontFamily="DM Sans"
        fontWeight="800" textAnchor="middle">3</text>
      <circle cx="526" cy="155" r="7" fill="none" stroke="rgba(14,165,233,0.70)" strokeWidth="1.2">
        <animate attributeName="r" values="7;20" dur="2.7s" begin="1.2s" repeatCount="indefinite"/>
        <animate attributeName="opacity" values="0.8;0" dur="2.7s" begin="1.2s" repeatCount="indefinite"/>
      </circle>
    </g>

    {/* ── WORKER — admin placing pins on tablet ── */}
    <g style={{ animation: 'workerBob 4.5s ease-in-out infinite', transformOrigin: '680px 370px' }}>
      {/* legs */}
      <rect x="672" y="340" width="10" height="30" rx="3" fill="#0C1830"/>
      <rect x="686" y="340" width="10" height="30" rx="3" fill="#0C1830"/>
      {/* boots */}
      <rect x="670" y="366" width="14" height="6" rx="2" fill="#060E1C"/>
      <rect x="684" y="366" width="14" height="6" rx="2" fill="#060E1C"/>
      {/* torso */}
      <rect x="668" y="292" width="32" height="50" rx="5" fill="#0C1830"/>
      <rect x="668" y="292" width="32" height="50" rx="5" fill="rgba(14,165,233,0.05)"/>
      {/* collar accent */}
      <rect x="668" y="314" width="32" height="3" rx="1" fill="rgba(245,158,11,0.09)"/>

      {/* arms holding tablet */}
      <rect x="645" y="302" width="25" height="9" rx="4" fill="#0C1830"/>
      <rect x="699" y="302" width="22" height="9" rx="4" fill="#0C1830"/>

      {/* ── Tablet in hands ── */}
      <rect x="638" y="286" width="92" height="60" rx="6"
        fill="#08111E" stroke="rgba(14,165,233,0.28)" strokeWidth="1.2"/>
      {/* tablet screen */}
      <rect x="643" y="291" width="82" height="50" rx="4"
        fill="#060E1C"/>
      {/* mini diagram on tablet */}
      {[0,1].map(row => [0,1,2].map(col => (
        <rect key={`${row}-${col}`}
          x={647 + col * 26} y={295 + row * 20}
          width={20} height={13} rx="2"
          fill="rgba(14,165,233,0.07)"
          stroke="rgba(14,165,233,0.20)" strokeWidth="0.6"/>
      )))}
      {/* mini pin on tablet */}
      <circle cx="657" cy="301" r="3.5" fill="#F59E0B" filter="url(#pinGlow)">
        <animate attributeName="opacity" values="1;0.4;1" dur="1.8s" repeatCount="indefinite"/>
      </circle>
      <circle cx="683" cy="314" r="3.5" fill="#EF4444" filter="url(#pinGlow)">
        <animate attributeName="opacity" values="0.5;1;0.5" dur="2.2s" begin="0.5s" repeatCount="indefinite"/>
      </circle>
      {/* stylus in right hand */}
      <line x1="718" y1="300" x2="700" y2="318"
        stroke="#1E3A5F" strokeWidth="3" strokeLinecap="round"/>
      <circle cx="700" cy="318" r="2" fill="#0EA5E9" filter="url(#pinGlow)">
        <animate attributeName="opacity" values="1;0.2;1" dur="0.9s" repeatCount="indefinite"/>
      </circle>

      {/* neck */}
      <rect x="677" y="277" width="12" height="16" rx="4" fill="#0C1830"/>
      {/* head */}
      <ellipse cx="683" cy="267" rx="15" ry="16" fill="#0C1830"/>
      {/* hard hat */}
      <ellipse cx="683" cy="254" rx="17" ry="7" fill="#0B1626"/>
      <rect x="667" y="251" width="32" height="8" rx="3" fill="#0C1E36"/>
    </g>

    {/* ground glow under worker */}
    <ellipse cx="683" cy="372" rx="28" ry="5" fill="rgba(245,158,11,0.05)">
      <animate attributeName="opacity" values="0.4;0.9;0.4" dur="2s" repeatCount="indefinite"/>
    </ellipse>

    {/* ── LEFT PANEL ARRAY (background depth) ── */}
    <g opacity="0.40">
      <rect x="50" y="225" width="6" height="145" fill="#0A1525"/>
      <rect x="130" y="218" width="6" height="152" fill="#0A1525"/>
      <rect x="50" y="223" width="86" height="4" fill="#0A1525"/>
      {[0,1,2].map(c => (
        <g key={c}>
          <rect x={54+c*28} y={228} width={22} height={135} rx="2"
            fill="url(#panelBody)" stroke="rgba(14,165,233,0.18)" strokeWidth="0.6"/>
          <rect x={54+c*28} y={228} width={13} height={67} rx="1"
            fill="url(#panelGlare)" opacity="0.40"/>
          <line x1={54+c*28+11} y1={232} x2={54+c*28+11} y2={358}
            stroke="rgba(14,165,233,0.12)" strokeWidth="0.5"/>
        </g>
      ))}
    </g>

    {/* ── Floating stat chips ── */}
    {/* "3 Points Marked" chip */}
    <g style={{ animation: 'fadeIn 0.6s 4.0s both' }}>
      <rect x="680" y="175" width="115" height="30" rx="6"
        fill="#0D1829" stroke="rgba(14,165,233,0.22)" strokeWidth="0.8"/>
      <circle cx="697" cy="190" r="5" fill="rgba(14,165,233,0.15)" stroke="rgba(14,165,233,0.35)" strokeWidth="0.8"/>
      <text x="697" y="194" fill="#0EA5E9" fontSize="7" fontFamily="DM Mono"
        fontWeight="700" textAnchor="middle">3</text>
      <text x="710" y="188" fill="rgba(255,255,255,0.38)"
        fontSize="8" fontFamily="DM Sans" fontWeight="600">Points Marked</text>
      <text x="710" y="199" fill="rgba(245,158,11,0.45)"
        fontSize="7" fontFamily="DM Mono">Site B · Sector 2</text>
    </g>

    {/* "1 Critical Flag" chip */}
    <g style={{ animation: 'fadeIn 0.6s 4.3s both' }}>
      <rect x="680" y="215" width="115" height="26" rx="6"
        fill="#0D1829" stroke="rgba(239,68,68,0.22)" strokeWidth="0.8"/>
      <circle cx="696" cy="228" r="4" fill="rgba(239,68,68,0.18)">
        <animate attributeName="opacity" values="0.6;1;0.6" dur="1.5s" repeatCount="indefinite"/>
      </circle>
      <text x="710" y="225" fill="rgba(255,255,255,0.35)"
        fontSize="8" fontFamily="DM Sans" fontWeight="600">1 Critical Flag</text>
      <text x="710" y="235" fill="rgba(239,68,68,0.50)"
        fontSize="7" fontFamily="DM Mono">Repair Needed</text>
    </g>

  </svg>
);

// ─── MAIN COMPONENT ───────────────────────────────────────────────
const MideastLogin = () => {
  const [showPass, setShowPass] = useState(false);
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const [passErr, setPassErr]   = useState('');
  const [error, setError]       = useState('');
  const [submitting, setSub]    = useState(false);
  const navigate = useNavigate();

  const validate = () => {
    let ok = true;
    if (!email) { setEmailErr('Email is required'); ok = false; }
    else if (!/\S+@\S+\.\S+/.test(email)) { setEmailErr('Enter a valid email'); ok = false; }
    else setEmailErr('');
    if (!password) { setPassErr('Password is required'); ok = false; }
    else setPassErr('');
    return ok;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSub(true); setError('');

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/mideast/auth/login`,
        { email, password }
      );

      // Store token + user under mideast-specific keys
      localStorage.setItem('mideast_token', data.token);
      localStorage.setItem('mideast_user',  JSON.stringify(data.user));

      const routes = {
        'mideast-admin':    '/me/admin',
        'mideast-customer': '/me/dashboard',
      };

      navigate(routes[data.user.type] || '/me/admin');

    } catch (err) {
      const msg = err?.response?.data?.error;
      if (msg === 'Account is inactive') {
        setError('Your account is inactive. Contact your administrator.');
      } else {
        setError('Invalid email or password.');
      }
    } finally {
      setSub(false);
    }
  };

  return (
    <div className="ml-root">
      <style>{STYLES}</style>
      <div className="ml-boot"/>
      <div className="ml-scanlines"/>

      {/* ══ LEFT ════════════════════════════════════════ */}
      <div className="ml-left">
        <div className="ml-deep-bg"/>
        <div className="ml-noise"/>
        <div className="ml-orb ml-orb-1"/>
        <div className="ml-orb ml-orb-2"/>
        <div className="ml-orb ml-orb-3"/>
        <div className="ml-shimmer"/>
        <div className="ml-grid"/>
        <div className="ml-hline" style={{ top:'35%', animation:'fadeIn 1.2s 1.8s both' }}/>
        <div className="ml-hline" style={{ top:'62%', opacity:0.4, animation:'fadeIn 1.2s 2.0s both' }}/>

        {/* Particles */}
        {PARTICLES.map(p => (
          <div key={p.id} className="ml-particle" style={{
            left:`${p.x}%`, top:`${p.y}%`,
            width:p.size, height:p.size,
            background:p.color,
            '--dx':p.dx, '--op':p.op,
            opacity:p.op,
            animationDelay:`${p.delay}s`,
            animationDuration:`${p.dur}s`,
          }}/>
        ))}

        {/* Scene */}
        <div className="ml-scene" style={{ animation:'fadeIn 0.9s 1.2s both' }}>
          <Scene/>
        </div>

        {/* Text overlay */}
        <div className="ml-left-inner">
          <div className="ml-brand">
            <img src={logo} alt="iNOVAA" className="ml-brand-logo" />
            <span className="ml-brand-sub">Mideast Operations</span>
          </div>

          <div className="ml-hero">
            <div className="ml-hero-eyebrow">
              <span className="ml-eyebrow-line"/>
              <span className="ml-eyebrow-text">Visual Site Intelligence</span>
            </div>
            <div className="ml-hero-title">
              Every panel.<br/><em>Every detail.</em>
            </div>
            <p className="ml-hero-body">
              Diagram-driven site management — mark points, attach notes,
              and track before &amp; after with precision.
            </p>
          </div>

          <div className="ml-powered-wrap">
            <div className="ml-powered-divider"/>
            <div className="ml-powered-label">Powered by</div>
            <div className="ml-badge">
              <div className="ml-badge-icon">i</div>
              <div>
                <img src={logo} alt="iNOVAA" className="ml-badge-logo" />
                <span className="ml-badge-sub">Mideast Edition</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ══ DIVIDER ══════════════════════════════════════ */}
      <div className="ml-divider">
        <div className="ml-divider-gem"/>
      </div>

      {/* ══ RIGHT ════════════════════════════════════════ */}
      <div className="ml-right">
        <div className="ml-bracket ml-bracket-tr"/>
        <div className="ml-bracket ml-bracket-bl"/>

        <div className="ml-card">
          <div className="ml-card-head">
            <div className="ml-eyebrow-row">
              <div className="ml-eyebrow-dash"/>
              <span className="ml-eyebrow-tag">Mideast Portal</span>
            </div>
            <div className="ml-card-title">Welcome back.</div>
            <div className="ml-card-sub">Sign in to access your Mideast operations dashboard.</div>
          </div>

          <form onSubmit={handleSubmit} noValidate>
            <div className="ml-field">
              <div className="ml-label">Email Address</div>
              <div className="ml-input-wrap">
                <span className="ml-input-icon">✉</span>
                <input
                  type="email"
                  className={`ml-input${emailErr ? ' has-error' : ''}`}
                  placeholder="you@company.com"
                  value={email}
                  onChange={e => { setEmail(e.target.value); setEmailErr(''); }}
                  autoComplete="email"
                />
                <div className="ml-uline"/>
              </div>
              {emailErr && <div className="ml-error-msg">⚠ {emailErr}</div>}
            </div>

            <div className="ml-field">
              <div className="ml-label">Password</div>
              <div className="ml-input-wrap">
                <span className="ml-input-icon">🔑</span>
                <input
                  type={showPass ? 'text' : 'password'}
                  className={`ml-input${passErr ? ' has-error' : ''}`}
                  placeholder="••••••••••"
                  value={password}
                  onChange={e => { setPassword(e.target.value); setPassErr(''); }}
                  autoComplete="current-password"
                  style={{ paddingRight: 42 }}
                />
                <button type="button" className="ml-eye" onClick={() => setShowPass(s => !s)}>
                  {showPass ? '🙈' : '👁'}
                </button>
                <div className="ml-uline"/>
              </div>
              {passErr && <div className="ml-error-msg">⚠ {passErr}</div>}
            </div>

            {error && (
              <div className="ml-alert">
                <span>⚠</span>{error}
              </div>
            )}

            <div className="ml-field" style={{ marginBottom: 0 }}>
              <button type="submit" className="ml-btn" disabled={submitting}>
                <div className="ml-btn-shine"/>
                {submitting
                  ? <><span className="ml-spin"/>Authenticating…</>
                  : 'Sign In →'
                }
              </button>
            </div>
          </form>

          <div className="ml-footer">
            Need access? Contact your <strong style={{ color: 'rgba(245,158,11,0.50)' }}>Mideast admin</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MideastLogin;